import { render, staticRenderFns } from "./order-view-product.vue?vue&type=template&id=5e47eec2&"
import script from "./order-view-product.ts?vue&type=script&lang=ts&"
export * from "./order-view-product.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports